import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PackagePriceService', PackagePriceService);

  PackagePriceService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'PackagePriceModalService',
  ];

  function PackagePriceService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    PackagePriceModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'packages';

    var service = {
      searchPackagePrices: searchPackagePrices,
      savePackagePrices: savePackagePrices,
      searchSuggestedPackagePrices: searchSuggestedPackagePrices,
      openSuggestedPackagePricesModal: openSuggestedPackagePricesModal,
    };

    return service;

    ////////////////

    function searchPackagePrices(pack, filterCriteria) {
      var url = apiUrl + '/' + pack.id + '/package_prices';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = pack.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function savePackagePrices(pack, params, editMode) {
      var url = apiUrl + '/' + pack.id + '/package_prices';

      params.company_id = pack.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'PRICES_ADDED' : 'UPDATED_PRICES';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }

    function searchSuggestedPackagePrices(pack, filterCriteria) {
      var url = apiUrl + '/' + pack.id + '/package_prices/get_suggested_prices';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = pack.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function openSuggestedPackagePricesModal(data, successCallback) {
      PackagePriceModalService.openSuggestedPackagePricesModal(data, successCallback);
    }
  }
})();
